import {classes, StyledNoData} from './SummaryComponentStyles'
import {Box, Paper, Stack, Typography} from '@mui/material'
import PropTypes from 'prop-types'
import {SuperscriptGreyDagger} from '../../common/Dagger'

const SummaryData = ({data, isZeroCountPopulation, handlePersonaCustomLabel}) => {
  return (
    <Box className={classes.summaryDataBox}>
      <Paper elevation={1} className={classes.summaryPadding}>
        <Stack direction="row" useFlexGap className={classes.summaryCommMainStack} gap={1}>
          {isZeroCountPopulation ? (
            <StyledNoData>
              No data to display <SuperscriptGreyDagger />
            </StyledNoData>
          ) : (
            data?.map((item, index) => (
              <Stack
                className={[
                  classes.summaryCommStack,
                  classes.wide,
                  typeof item.title === 'string' && item.title.includes('$') ? classes.wide1 : ''
                ]}
                key={index + item}
                tabIndex={0}
                spacing={1}
                direction="column"
                aria-label={`${item.title}, ${item.text}`}
              >
                <Typography className={[classes.summaryStackTitle, classes.summaryTitleColorTeal]}>
                  {item.title}
                </Typography>
                <Typography className={[classes.summaryStackText]}>{handlePersonaCustomLabel(item.text)}</Typography>
              </Stack>
            ))
          )}
        </Stack>
      </Paper>
    </Box>
  )
}

SummaryData.propTypes = {
  data: PropTypes.array.isRequired,
  isZeroCountPopulation: PropTypes.bool.isRequired,
  handlePersonaCustomLabel: PropTypes.func.isRequired
}

export default SummaryData
